
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/tracks/[slug]",
      function () {
        return require("private-next-pages/business/tracks/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/tracks/[slug]"])
      });
    }
  